interface ToggleSwitchProps {
  disabledLabel: string
  enabledLabel: string
  size: 'small' | 'normal'
  name: string
  onChange: () => void
  onBlur: () => void
  value: boolean
}

export default function ToggleSwitch({
  disabledLabel,
  enabledLabel,
  size = 'normal',
  name,
  onChange,
  onBlur,
  value,
}: ToggleSwitchProps) {
  const sizes = {
    normal: {
      width: 'w-14',
      height: 'h-8',
      afterSize: 'after:w-6 after:h-6',
      fontSize: '',
    },
    small: {
      width: 'w-12',
      height: 'h-4',
      afterSize: 'after:w-4 after:h-4',
      fontSize: 'text-xs',
    },
  }

  const effectiveSize = size && sizes[size] ? sizes[size] : sizes.normal

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex justify-center items-end">
        <span className={`${effectiveSize.fontSize} mb-0 mr-2`}>
          {disabledLabel}
        </span>
        <label
          className={`relative inline-flex items-center cursor-pointer
            ${effectiveSize.width}
            ${effectiveSize.height}`}
          htmlFor={name}
        >
          <input
            type="checkbox"
            checked={value}
            name={name}
            id={name}
            onChange={onChange}
            onBlur={onBlur}
            className="sr-only peer"
          />
          <span
            className={`${effectiveSize.width}
            ${effectiveSize.height}
            flex
            items-center
            ml-0
            p-0
            bg-primary-500
            rounded-full
            duration-300
            ease-in-out
            peer-checked:bg-ircamprimary-accent
            ${effectiveSize.afterSize}
            after:bg-white
            after:rounded-full
            after:shadow-md
            after:absolute
            after:duration-300
            after:ml-1
            peer-checked:after:translate-x-[100%]`}
          />
        </label>
        <span className={`${effectiveSize.fontSize} mb-0 ml-2`}>
          {enabledLabel}
        </span>
      </div>
    </div>
  )
}
